import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { toI18n } from 'util/i18n';

const SendLinkToScheduleModal = () => (
  <Box mb={16}>
    <Text>
      {toI18n('hiring.candidates_review.modals.send_link_to_schedule_text')}
    </Text>
  </Box>
);

export default SendLinkToScheduleModal;
